exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".lp-menu-child[data-v-855e872a],.lp-menu-item[data-v-855e872a]{padding:16px 20px;padding-right:12px;cursor:pointer}.lp-menu-item[data-v-855e872a]{color:#fff;border-top:1px solid #fff;background-color:$primary}.lp-menu-child[data-v-855e872a]{background-color:#fff;color:$darkgrey;padding-left:28px;border-bottom:1px solid #ddd}.lp-menu-child[data-v-855e872a]:last-child{border-bottom:0}.lp-menu-child[data-v-855e872a]:hover,.selected[data-v-855e872a]{color:$primary}", ""]);

// exports
